import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import LoadingLayer from '../../controls/LoadingLayer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'react-bootstrap-button-loader';
import * as StatusCode from '../../../scripts/StatusCode';
import { deleteAvailability } from '../../../actions/availability';
import i18next from 'i18next';
import styles from '../../../styles/scheduleAvailability.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashXmark } from "@fortawesome/pro-duotone-svg-icons";

const useStyles = (theme) => ({
    buttons: {
        float: 'left'
    },
    divPeriod: {
        float: 'right'
    },
    spanDay: {
        float: 'left',
        padding: '4px',
        color: '#cfcfcf',
        fontWeight: 'bold'
    },
    spanDayEnabled: {
        color: 'var(--color1)'
    },
    spanLabel: {
        fontWeight: 'bold'
    },
    spanValue: {
        marginLeft: '5px',
        marginRight: '15px'
    },
    listItem: {
        borderTop: '1px solid #e1e1e1'
    },
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    icons: {
        color: '#3f51b5 !important'
    },
});

class ListAvailability extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dense: false,
            data: [],
            secondary: false,
            isProcessing: true,
            openConfirmDelete: false,
            daysIdDelete: { day1Id: 0, day2Id: 0, day3Id: 0, day4Id: 0, day5Id: 0, day6Id: 0, day7Id: 0 }
        }
    }

    componentDidMount() {
        this.setState({ isProcessing: false });
    }

    loadData = async (id) => {
        return new Promise((resolve) => {
            this.setState({
                data: this.props.data.filter(x => x.id == id)
            }, () => {
                resolve(this.state.data.length);
            })
        });
    }

    handleEdit = (id, lineId) => {
        this.props.handleEditAvailability(id, lineId);
    }

    handleDelete = async () => {
        const response = await deleteAvailability(this.state.daysIdDelete.day1Id, this.state.daysIdDelete.day2Id,
            this.state.daysIdDelete.day3Id, this.state.daysIdDelete.day4Id, this.state.daysIdDelete.day5Id,
            this.state.daysIdDelete.day6Id, this.state.daysIdDelete.day7Id);

        if (response == null || (response != null && response.status != StatusCode.STATUS_OK)) {
            // Error
            this.props.showMessageError(i18next.t('error:generic-error'));
            return;
        }

        this.setState({ openConfirmDelete: false });

        const deleteMode = 1;
        this.props.handleReloadList(deleteMode);
    }

    handleOpenConfirmDelete = (day1Id, day2Id, day3Id, day4Id, day5Id, day6Id, day7Id) => {
        this.setState({
            daysIdDelete: {
                day1Id: day1Id, day2Id: day2Id, day3Id: day3Id, day4Id: day4Id, day5Id: day5Id, day6Id: day6Id, day7Id: day7Id
            },
            openConfirmDelete: true
        });
    }

    handleCloseConfirmDelete = () => {
        this.setState({ openConfirmDelete: false });
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={styles.konekCard} style={{ top: (this.props.comment ? '150px' : '80px') }}>
                <LoadingLayer isActive={this.state.isProcessing}>
                    <List dense={this.state.dense}>
                        {this.state.data != null && this.state.data.map((obj, index) =>
                            <ListItem key={index} className="listItem" onClick={() => this.handleEdit(obj.id, obj.lineId)}>
                                <ListItemText
                                    primary={
                                        <React.Fragment>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('scheduleAvailability:list.startTime')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.startTime}
                                            </span>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('scheduleAvailability:list.endTime')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.endTime}
                                            </span>
                                        </React.Fragment>
                                    }
                                    secondary={
                                        <React.Fragment>
                                            <span className={`${classes.spanDay} ${obj.day1 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.sundayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day2 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.mondayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day3 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.tuesdayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day4 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.wednesdayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day5 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.thursdayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day6 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.fridayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day7 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.saturdayAbbr')}
                                            </span>
                                        </React.Fragment>
                                    }
                                />
                                <ListItemSecondaryAction className={classes.divAction}>
                                    <IconButton edge="end" aria-label="delete" onClick={() => this.handleOpenConfirmDelete(obj.day1Id, obj.day2Id,
                                        obj.day3Id, obj.day4Id, obj.day5Id, obj.day6Id, obj.day7Id)}>
                                        <FontAwesomeIcon icon={faTrashXmark} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        )}
                    </List>
                    <Dialog
                        open={this.state.openConfirmDelete}
                        onClose={this.handleCloseConfirmDelete}
                        aria-labelledby="draggable-dialog-title"
                    >
                        <DialogTitle id="draggable-dialog-title">
                            Confirmation
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {i18next.t('common:confirmDelete')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button autoFocus onClick={() => this.handleDelete()} color="primary" className={styles.buttonYesNo} variant="success">
                                {i18next.t('buttons:yes')}
                            </Button>
                            <Button onClick={this.handleCloseConfirmDelete} color="primary" className={styles.buttonYesNo} variant="success">
                                {i18next.t('buttons:no')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </LoadingLayer>
            </div>
        )
    }
}

export default withNamespaces(['buttons', 'scheduleAvailability', 'common'], {
    wait: true,
    innerRef: (ref) => {
        ref?.props.setListRef(ref)
    }
})(withStyles(useStyles)(ListAvailability));